import React from 'react';
import styles from './styles.css';

export default function ViewPickerMenu({ description, views, show }) {
	return (
		<div className={`app-menu view-menu ${styles.viewPickerWrapper} ${!show ? 'uk-hidden' : ''}`}>
			<div className="uk-container icon-container"></div>
			<div className="app-menu-inner">
				<p className="menu-description">{description}</p>
				<div className={styles.cardGrid} role="group" aria-label="View options">
					{views.map((view) => (
						<button
							key={view.class.toLowerCase()}
							className={`${styles.card} ${view.isSelected ? styles.cardSelected : ''}`}
							onClick={() => view.onClick()}
							type="button"
						>
							{view.icon && <img src={view.icon} alt="" className={styles.cardIcon} />}
							<span className={styles.cardLabel}>{view.label}</span>
						</button>
					))}
				</div>
			</div>
		</div>
	);
}
